/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 500px; }\n\n.btn-add[_ngcontent-%COMP%] {\n  background-color: var(--btn-add-coloe);\n  color: white; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.scss.shim.ngstyle.js.pre-build-optimizer.js